import { WordCloudChart } from '@components/charts/WordCloudChart'
import React, { useMemo } from 'react'
import { useInView } from '../../hooks/useInView'
import { usePrinting } from '../../hooks/usePrinting'
import type { Feedback } from '../../types'
import styles from './feedback.module.sass'
import { wordColour } from './utils'

type Keyword = Feedback['keywords'][number]

const cloudOptions = (keywords: Keyword[]) => ({
  deterministic: true,
  enableTooltip: false,
  fontFamily: "'Kanit', sans-serif",
  fontSizes: [18, 64],
  fontWeight: '600',
  padding: 4,
  // No flying words: the cloud fades in as a whole instead (CSS).
  transitionDuration: 0,
  callbacks: { getWordColor: wordColour(keywords) },
})

// Mounts once on screen (or for a printout), so its fade plays where people
// see it. The words and their counts are listed in About this data.
export const WordCloud = ({ keywords }: { keywords: Keyword[] }) => {
  const [ref, inView] = useInView<HTMLDivElement>()
  const printing = usePrinting()
  const words = useMemo(() => keywords.map((keyword) => ({ text: keyword.word, value: keyword.count })), [keywords])
  const options = useMemo(() => cloudOptions(keywords), [keywords])
  const label = `Most used words: ${keywords.map((keyword) => keyword.word).join(', ')}`

  return (
    <div ref={ref} className={styles.cloud}>
      <div className={styles.cloudWords} role="img" aria-label={label}>
        {inView || printing ? <div className={styles.cloudFade}><WordCloudChart words={words} options={options} height="medium" /></div> : null}
      </div>
      <p className={styles.cloudLegend}>Bigger words come up more often. Orange words come mostly from critical comments.</p>
    </div>
  )
}
